"use client";

import { createSVGIcon } from "@faire/web/slate/icons/util";
import React from "react";

export const SocialX = createSVGIcon(
  <>
    <path
      d="M0 0L11.3548 16H16L4.64516 0H0ZM2.99754 1.54839L12.1547 14.4516H13.0025L3.84534 1.54839H2.99754Z"
      fill="#333333"
    />
    <path
      d="M1.54814 16H0.257812L13.9352 0H15.2256L1.54814 16Z"
      fill="#333333"
    />
  </>,
  "SocialX",
  (strictLocalize) => ({
    viewBox: "0 0 16 16",
    titleAccess: strictLocalize({
      defaultMessage: "X icon",
      description: {
        text: "svg icon for social app X",
      },
    }),
    fill: "none",
  })
);
